<section
  class="ui-app-shell"
  [class.ui-app-shell-with-tabbar]="hasTabbar()"
  [attr.aria-label]="ariaLabel()"
  data-testid="nexus-mobile-app-shell"
>
  <div class="ui-app-shell-header">
    <ng-content select="[uiAppShellHeader]" />
  </div>

  <main class="ui-app-shell-body">
    <ng-content />
  </main>

  @if (hasTabbar()) {
    <footer class="ui-app-shell-tabbar">
      <ng-content select="[uiAppShellTabbar]" />
      <div
        class="ui-app-shell-home-indicator"
        data-testid="nexus-mobile-home-indicator"
        aria-hidden="true"
      ></div>
    </footer>
  }
</section>
